export default {
  // Core
  SET_IS_LOCKED: 'SET_IS_LOCKED',
  SET_IS_SYNC: 'SET_IS_SYNC',
  SET_SYNCING: 'SET_SYNCING',

  // System
  CHANGE_LANGUAGE: 'CHANGE_LANGUAGE',
  TOGGLE_LOADING: 'TOGGLE_LOADING',
  SET_CURRENT_PAGE: 'SET_CURRENT_PAGE',
  SET_IS_MOBILE: 'SET_IS_MOBILE',
  SET_IS_COLUMN: 'SET_IS_COLUMN',
  SET_COLLAPSED: 'SET_COLLAPSED',
  SET_CACHE_DATA: 'SET_CACHE_DATA',
  SET_IS_SCROLL_TO_TOP: 'SET_IS_SCROLL_TO_TOP',
  SET_SOCKET_LAST_MESSAGE: 'SET_SOCKET_LAST_MESSAGE',

  // Auth
  SET_USER_INFO: 'SET_USER_INFO',
  SET_FACTOR2: 'SET_FACTOR2',
  SET_LOGIN_INFO: 'SET_LOGIN_INFO',

  // Workspace
  SET_WORKSPACES: 'SET_WORKSPACES',
  SET_WS_ROLE: 'SET_WS_ROLE',
  SET_SELECTED_WORKSPACE: 'SET_SELECTED_WORKSPACE',
  SET_PROGRESS_DATA: 'SET_PROGRESS_DATA',
  SET_PROGRESS_DRAWERS: 'SET_PROGRESS_DRAWERS',

  // Project
  SET_PROJECTS: 'SET_PROJECTS',
  SET_IS_FETCH_PROJECTS: 'SET_IS_FETCH_PROJECTS',
  SET_SELECTED_PROJECT: 'SET_SELECTED_PROJECT',
  SET_PROJECT_SECRETS: 'SET_PROJECT_SECRETS',
  SET_PROJECT_ENVIRONMENTS: 'SET_PROJECT_ENVIRONMENTS',
  SET_IS_FETCH_PROJECT_SECRETS: 'SET_IS_FETCH_PROJECT_SECRETS',
  SET_IS_FETCH_PROJECT_ENVIRONMENTS: 'SET_IS_FETCH_PROJECT_ENVIRONMENTS',

  // Onboarding
  SET_ONBOARDING_PROCESS: 'SET_ONBOARDING_PROCESS',
  SET_CREATE_PROJECT: 'SET_CREATE_PROJECT',
  SET_INSTALL_TOOL: 'SET_INSTALL_TOOL',
  SET_CREATE_SECRET: 'SET_CREATE_SECRET',
  SET_CREATE_ACCESS_KEY: 'SET_CREATE_ACCESS_KEY',
  SET_CHANGE_PROCESS_KEY: 'SET_CHANGE_PROCESS_KEY',
}